module.exports = __webpack_public_path__ + "img/service-nongmaozonghe2.bab565b5.svg";